export default "__VITE_ASSET__CtqnkpAf__"